export const ATTENDANCE = "ATTENDANCE";

export const getAttendanceQueue = () => {
  try {
    const stored = localStorage.getItem(ATTENDANCE);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const addToAttendanceQueue = (data) => {
  try {
    const queue = getAttendanceQueue();

    // Check for duplicates: same workerSlug + bookingRequestSlug + time (within 1 minute)
    const isDuplicate = queue.some((item) => {
      const sameWorkerAndBooking =
        item.workerSlug === data.workerSlug && item.bookingRequestSlug === data.bookingRequestSlug;

      if (!sameWorkerAndBooking) return false;

      // Check if timestamps are within 1 minute (to handle same scan multiple times)
      const itemTime = new Date(item.time).getTime();
      const dataTime = new Date(data.time).getTime();
      const timeDiff = Math.abs(dataTime - itemTime);
      const oneMinute = 60 * 1000; // 1 minute in milliseconds

      return timeDiff < oneMinute;
    });

    if (isDuplicate) {
      console.log("Duplicate attendance entry prevented:", data);
      return false; // Don't add duplicate
    }

    queue.push(data);
    localStorage.setItem(ATTENDANCE, JSON.stringify(queue));
    return true;
  } catch {
    return false;
  }
};

export const removeFromAttendanceQueue = (index) => {
  try {
    const queue = getAttendanceQueue();
    queue.splice(index, 1);
    localStorage.setItem(ATTENDANCE, JSON.stringify(queue));
    return true;
  } catch {
    return false;
  }
};

export const clearAttendanceQueue = () => {
  try {
    localStorage.removeItem(ATTENDANCE);
    return true;
  } catch {
    return false;
  }
};
